/**
 * duzenlemeTalebi.js — the small shared piece of the Edit Kişi Request screens (backlog #749): the lock codes (`kilitSebepleri`) as one sentence part.
 * `t` is the `components` namespace's translate function. An unknown code (the backend may add one) is shown as it is.
 */
export function kilitMetni(t, kodlar) {
  return (kodlar || []).map((k) => t(`duzenlemeTalebi.kilit.${k}`, { defaultValue: k })).join(', ');
}
